import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import BottomNav from './bottom-nav';
import SideNav from './side-nav';
import { useAuth } from '../../../global/contexts/auth/auth';
import { useDevice } from '../../../global/contexts/device/device';
import { useTasksList } from '../../../global/contexts/work/work';
import { visibleMenu } from '../menu';

import '../styles/shell.css';

export default function Shell() {
    const { can, canAny } = useAuth();
    const { isEmbedded } = useDevice();
    const location = useLocation();
    const mainRef = useRef(null);
    const isFirstRender = useRef(true);
    const { data: inReview } = useTasksList({ workflowState: 'in_review', limit: 1 });

    const items = visibleMenu({ can, canAny });
    const badges = { reviews: inReview?.total ?? 0 };

    // Move focus to the new page on navigation so keyboard and screen reader
    // users land on the content instead of the link they just activated.
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        mainRef.current?.focus({ preventScroll: true });
        window.scrollTo({ top: 0 });
    }, [location.pathname]);

    return (
        <div className={`app-shell${isEmbedded ? ' app-shell--embedded' : ''}`}>
            {/* With hash routing a plain #main-content link would be read as a route. */}
            <a
                className="skip-link"
                href="#main-content"
                onClick={(event) => {
                    event.preventDefault();
                    mainRef.current?.focus();
                }}
            >
                Saltar al contenido
            </a>
            <SideNav items={items} badges={badges} />
            <div className="app-shell__column">
                <main id="main-content" ref={mainRef} tabIndex={-1} className="app-shell__main">
                    <Outlet />
                </main>
            </div>
            <BottomNav items={items} badges={badges} />
        </div>
    );
}
